import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import Layout from '../components/fr';
import SEO from '../components/seo';

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        languages {
          defaultLangKey
          langs
        }
      }
    }
    allMarkdownRemark(
      filter: { fileAbsolutePath: { glob: "**/content/support/*.fr.md" } }
      sort: { order: ASC, fields: [frontmatter___order] }
    ) {
      edges {
        node {
          id
          html
          frontmatter {
            title
            lead
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;

const Support = ({ data }) => {
  const { edges: posts } = data.allMarkdownRemark;
  return (
    <Layout location={typeof window !== 'undefined' ? location : null}>
      <SEO
        title="Support - Furlan Snowboards"
        description="All you need to know when ordering on our site."
        pathname="/en/support/"
        keywords={['snowboard', 'boards', 'polyvalence']}
      />
      <div className="supportPage">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mt-5 mb-5">
              <p className="lead">
                Depuis 2011 nous n’avons eu aucun retour ou défaut de fabrication
                observé :) Depuis 2011, nos snowboards sont fabriqués en Pologne
                dans la meilleure usine de fabrication de skis et snowboards
                d’Europe.
              </p>
              <p className="lead">
                Vous achetez votre snowboard sur notre site, nous vous offrons une
                garantie de 2 ans et vous bénéficiez d’un service après vente
                personnalisé. Contactez nous en cas de besoin aux contacts indiqués
                sur le site.
              </p>
              <p className="lead">
                Durant cette période de 2 ans, si un défaut de
                fabrication est observé nous changeons votre planche. En cas de
                défaut minime et si possibilité, nous réparons votre planche. Le
                cas échéant nous changeons la planche.
              </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 content">
              {posts.map(({ node: post }) => (
                <Fragment key={post.id}>
                  <h2 className="mb-3">{post.frontmatter.title}</h2>
                  <p>
                    <div dangerouslySetInnerHTML={{ __html: post.html }} />
                  </p>
                  <br />
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Support;
